"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelephoneValuesMapper = void 0;
const TelephoneValuesMapper = exports.TelephoneValuesMapper = {
  toForm(dto) {
    return {
      connectWithWhatsApp: dto.connections ? dto.connections.whatsApp : false,
      connectWithEWallet: dto.connections ? dto.connections.eWallet : false,
      isPrimary: dto.isPrimary,
      isVerified: dto.isVerified,
      telephoneId: dto.telephoneId ?? 0,
      telephoneNumber: dto.telephoneNumber ?? '',
      telephoneType: dto.telephoneType
    };
  },
  toDto(values) {
    return {
      connections: {
        whatsApp: values.connectWithWhatsApp,
        eWallet: values.connectWithEWallet
      },
      isPrimary: values.isPrimary,
      isVerified: values.isVerified,
      telephoneId: values.telephoneId,
      telephoneNumber: values.telephoneNumber ?? '',
      telephoneType: values.telephoneType
    };
  }
};
//# sourceMappingURL=telephoneMapper.js.map